<template>
  <ProjectScaffold :loading="loadingFinalAssets || loadingWorkingFiles">
    <div class="tabs">
      <TabsNavigation :tab-definitions="tabDefinitions" v-model="selectedTabId" />
      <TabsContent :tab-definitions="tabDefinitions" v-model="selectedTabId" class="tabs-content">
        <div v-if="selectedTabId === 'final-assets'">
          <div class="header">
            <div class="titles">
              <div class="title">Your finals assets</div>
              <div class="subtitle">Here are the final assets you’ve approved.</div>
            </div>
            <div class="actions flex-row items-end">
              <div class="flex mb-4">
                <broadcasting-rights />
                <!-- <CreateFinalAsset
                  class="mb-4 ml-4"
                  v-if="canUpload"
                  :resumable="finalAssetsResumable"
                  @input="handleFinalAssetAdded"
                /> -->
              </div>
              <div class="">
                <FilterPicker :value="currentFinalAssetFilter" @input="handleFinalAssetFilterSelectChange" />
              </div>
            </div>
          </div>
          <ts-divider></ts-divider>
          <FinalAssetList :assets.sync="finalAssetsAndUploadingFinalAssets" @delete-asset="handleFinalAssetDelete" />
        </div>
        <div v-if="selectedTabId === 'working-files'">
          <div class="header">
            <div class="titles">
              <div class="title">Working files</div>
              <div class="subtitle">You can download here the project working files</div>
            </div>
            <div class="actions flex-row items-end">
              <CreateWorkingFile
                class="mb-4"
                v-if="canUpload"
                :resumable="workingFilesResumable"
                @input="handleWorkingFileAdded"
              />
              <div class="">
                <FilterPicker :value="currentWorkingFileFilter" @input="handleWorkingFileFilterSelectChange" />
              </div>
            </div>
          </div>
          <ts-divider></ts-divider>
          <WorkingFileList :assets="workingFilesAndUploadingWorkingFiles" @delete-asset="handleWorkingFileDelete" />
        </div>
        <div v-if="selectedTabId === 'file-requests'">
          <div class="header">
            <div class="titles">
              <div class="title">File requests</div>
              <div class="subtitle">
                Enables your creators to directly submit assets to the project without having to log in.
              </div>
            </div>
            <div class="actions flex-row items-end">
              <CreateFileRequest group="delivery" @input="handleFileRequestAdded" class="mb-4" />
              <div class="">
                <FilterPicker :value="currentFileRequestFilter" @input="handleFileRequestFilterSelectChange" />
              </div>
            </div>
          </div>
          <div class="requests-tabs">
            <ul class="list-reset flex">
              <li class="requests-tabs-item" :class="{ active: !showArchivedRequests }">
                <a href="#" class="" @click.prevent="showArchivedRequests = false"> Current requests </a>
                <span class="divider"></span>
              </li>
              <li class="requests-tabs-item" :class="{ active: showArchivedRequests }">
                <a href="#" class="" @click.prevent="showArchivedRequests = true"> Closed requests </a>
                <span class="divider"></span>
              </li>
            </ul>
          </div>
          <ts-divider></ts-divider>
          <file-request-list
            label="File requests"
            group="delivery"
            :file-requests="filteredFileRequests"
            @remove="handleFileRequestDelete"
            @update="handleFileRequestUpdate"
          ></file-request-list>
        </div>
      </TabsContent>
    </div>
  </ProjectScaffold>
</template>

<style lang="scss" scoped>
.list-reset {
  list-style: none;
  margin: 0;
}
.requests-tabs {
  margin-bottom: -1.6em;
}
.requests-tabs-item {
  &:hover .divider,
  &.active .divider {
    position: absolute;
    bottom: 0;
    left: 0;
    background: black;
    height: 3px;
    width: 100%;
    z-index: 999;
  }
  position: relative;
  display: block;
  & a {
    padding: 1em 1em;
    display: block;
  }
}
a {
  text-decoration: none;
  color: #6d7587;
}
.tabs {
  display: flex;

  .tabs-content {
    flex-grow: 1;
    padding: 40px 46px;
  }
}

.header {
  display: flex;

  .titles {
    flex-grow: 1;
  }

  .title {
    font-family: Roboto;
    font-size: 20px;
    color: #6d7587;
  }

  .subtitle {
    font-family: Roboto;
    font-size: 12px;
    color: #6d7587;

    margin-top: 12px;
  }

  .actions {
    flex-shrink: 0;
    margin-left: 50px;
    display: flex;

    > * {
      margin-left: 10px;
    }
  }
}
.hidden {
  display: none;
}
.flex-row {
  flex-direction: column;
}
.mr-4 {
  margin-right: 1rem;
}
.items-end {
  align-items: flex-end;
}
.mb-4 {
  margin-bottom: 1rem;
}
.mb-2 {
  margin-bottom: 0.5rem;
}
.flex {
  display: flex;
}
.flex-row {
  flex-direction: column;
}
.items-end {
  align-items: flex-end;
}
.ml-4 {
  margin-left: 1rem;
}
.mb-4 {
  margin-bottom: 1rem;
}
.mb-2 {
  margin-bottom: 0.5rem;
}
.tabs {
  display: flex;

  .tabs-content {
    flex-grow: 1;
    padding: 40px 46px;
  }
}

.header {
  display: flex;

  .titles {
    flex-grow: 1;
  }

  .title {
    font-family: Roboto;
    font-size: 20px;
    color: #6d7587;
  }

  .subtitle {
    font-family: Roboto;
    font-size: 12px;
    color: #6d7587;

    margin-top: 12px;
  }

  .actions {
    flex-shrink: 0;
    margin-left: 50px;
    display: flex;

    > * {
      margin-left: 10px;
    }
  }
}
</style>

<script>
import { mapState, mapActions } from 'vuex';
import { orderBy } from 'lodash';
import moment from 'moment';

import ProjectScaffold from '../ProjectScaffold.vue';
import FinalAssetList from './FinalAssetList.vue';
import CreateFinalAsset from './CreateFinalAsset.vue';
import WorkingFileList from './WorkingFileList.vue';
import CreateWorkingFile from './CreateWorkingFile.vue';
import TabsNavigation from '@/components/TabsNavigation.vue';
import TabsContent from '@/components/TabsContent.vue';
import FilterPicker from '@/components/inputs/FilterPicker.vue';
import FileRequestList from '../assets/FileRequestList.vue';
import CreateFileRequest from '../assets/CreateFileRequest.vue';

import projectViewHelpers from '@/mixins/projectViewHelpers';
import { buildResumable } from '@/mixins/uploader';
import BroadcastingRights from './BroadcastingRights.vue';

const removeExtension = value => {
  const reg = new RegExp(/(\.\w*$)/);
  return isNaN(value) ? value.replace(reg, '') : parseInt(value);
};

export default {
  mixins: [projectViewHelpers],
  components: {
    ProjectScaffold,
    FinalAssetList,
    FileRequestList,
    CreateFileRequest,
    CreateFinalAsset,
    WorkingFileList,
    CreateWorkingFile,
    TabsNavigation,
    TabsContent,
    FilterPicker,
    BroadcastingRights
  },
  data() {
    return {
      selectedTabId: 'final-assets',
      finalAssetsResumable: buildResumable(),
      uploadingFinalAssets: [],
      workingFilesResumable: buildResumable(),
      uploadingWorkingFiles: [],
      workingFileFilter: 'latest',
      finalAssetFilter: 'latest',
      fileRequestsItems: [],
      fileRequestFilter: 'latest',
      showArchivedRequests: false,
      filterOptions: {
        latest: { field: 'createdAt', order: 'asc', handler: asset => moment(asset.createdAt).unix() },
        oldest: { field: 'createdAt', order: 'desc', handler: asset => moment(asset.createdAt).unix() },
        asc: {
          field: 'name',
          order: 'asc',
          handler(asset) {
            const name = removeExtension(asset.name);
            return isNaN(name) ? name : parseInt(name);
          }
        },
        desc: {
          field: 'name',
          order: 'desc',
          handler(asset) {
            const name = removeExtension(asset.name);
            return isNaN(name) ? name.toLowerCase() : parseInt(name);
          }
        }
      }
    };
  },
  computed: {
    ...mapState('workflow/delivery', {
      loadingFinalAssets: state => state.finalAssets.loading,
      finalAssets: state => state.finalAssets.items,
      finalAssetsError: state => state.finalAssets.error,
      loadingWorkingFiles: state => state.workingFiles.loading,
      workingFiles: state => state.workingFiles.items,
      workingFilesError: state => state.workingFiles.error
    }),
    fileRequests() {
      return this.fileRequestsItems;
    },
    currentFileRequestFilter() {
      return this.fileRequestFilter;
    },
    filteredFileRequests() {
      const { field, order, handler } = this.filterOptions[this.currentFileRequestFilter];
      const fileRequests = orderBy(this.fileRequests, [asset => (handler ? handler(asset) : asset[field])], [order]);

      return fileRequests.filter(item => item.archived === this.showArchivedRequests);
    },
    currentFinalAssetFilter() {
      return this.finalAssetFilter;
    },
    currentWorkingFileFilter() {
      return this.workingFileFilter;
    },
    canUpload() {
      return !this.isCustomer;
    },
    tabDefinitions() {
      return [
        {
          id: 'final-assets',
          name: 'Final assets'
        },
        {
          id: 'working-files',
          name: 'Working files'
        },
        {
          id: 'file-requests',
          name: 'File requests'
        }
      ];
    },
    finalAssetsAndUploadingFinalAssets() {
      const assets = [...this.finalAssets, ...this.uploadingFinalAssets];

      const { field, order, handler } = this.filterOptions[this.currentFinalAssetFilter];
      return orderBy(assets, [asset => (handler ? handler(asset) : asset[field])], [order]);
    },
    workingFilesAndUploadingWorkingFiles() {
      const assets = [...this.workingFiles, ...this.uploadingWorkingFiles];

      const { field, order, handler } = this.filterOptions[this.currentWorkingFileFilter];
      return orderBy(assets, [asset => (handler ? handler(asset) : asset[field])], [order]);
    }
  },
  methods: {
    ...mapActions('workflow/delivery', [
      'fetchCurrentProjectFinalAssets',
      'fetchCurrentProjectWorkingFiles',
      'addCurrentProjectFinalAsset',
      'addCurrentProjectWorkingFile'
    ]),
    ...mapActions('workflow/fileRequests', [
      'fetchCurrentProjectFileRequests',
      'addCurrentProjectFileRequest',
      'updateCurrentProjectFileRequest',
      'removeCurrentProjectFileRequest'
    ]),
    handleFileRequestAdded(fileRequest) {
      this.addCurrentProjectFileRequest({ fileRequest }).then(item => {
        this.fileRequestsItems.push({
          ...item,
          shouldOpen: true
        });
      });
    },
    handleFileRequestDelete(fileRequest) {
      this.removeCurrentProjectFileRequest({ fileRequest }).then(item => {
        this.fileRequestsItems = this.fileRequestsItems.filter(f => f.id != fileRequest.id);
      });
    },
    handleFileRequestUpdate(fileRequest) {
      this.updateCurrentProjectFileRequest({ fileRequest }).then(item => {
        this.fileRequestsItems = this.fileRequestsItems.map(f => {
          return f.id == fileRequest.id ? fileRequest : f;
        });
      });
    },
    handleFileRequestFilterSelectChange(value) {
      this.fileRequestFilter = value;
    },
    handleFinalAssetFilterSelectChange(value) {
      this.finalAssetFilter = value;
    },
    handleWorkingFileFilterSelectChange(value) {
      this.workingFileFilter = value;
    },
    async handleFinalAssetAdded(asset) {
      if (asset.type === 'uploaded-file') {
        this.uploadingFinalAssets = [
          ...this.uploadingFinalAssets,
          {
            ...asset,
            id: asset.resumableFile.uniqueIdentifier,
            platforms: [],
            createdAt: new Date().toISOString(),
            createdBy: this.currentUser
          }
        ];
        this.finalAssetsResumable.upload();
      }
    },
    async handleWorkingFileAdded(asset) {
      if (asset.type === 'uploaded-file') {
        this.uploadingWorkingFiles = [
          ...this.uploadingWorkingFiles,
          {
            ...asset,
            id: asset.resumableFile.uniqueIdentifier,
            users: [],
            createdAt: new Date().toISOString(),
            createdBy: this.currentUser
          }
        ];
        this.workingFilesResumable.upload();
      } else {
        try {
          await this.addCurrentProjectWorkingFile({
            asset: {
              ...asset,
              users: []
            }
          });
        } catch (err) {
          asset.uploadError = true;
          asset.uploadErrorMessage = err.message;
        }
      }
    },
    async handleFinalAssetSuccess(file) {
      const asset = this.uploadingFinalAssets.find(a => a.resumableFile.uniqueIdentifier == file.uniqueIdentifier);
      if (asset) {
        try {
          await this.addCurrentProjectFinalAsset({ asset });
          this.uploadingFinalAssets = this.uploadingFinalAssets.filter(
            a => a.resumableFile.uniqueIdentifier !== file.uniqueIdentifier
          );
        } catch (err) {
          console.error('Server error when adding final asset', err);
          asset.uploadError = true;
          asset.uploadErrorMessage = err.message;
          this.showError('Error when adding final asset');
        }
      }
    },
    handleFinalAssetError(file, message) {
      const asset = this.uploadingFinalAssets.find(
        a => a.uploadingFinalAssets.uniqueIdentifier == file.uniqueIdentifier
      );
      if (asset) {
        console.error('Server error when adding final asset', message);
        asset.uploadError = true;
        asset.uploadErrorMessage = message;
        this.showError('Error when adding final asset');
      }
    },
    handleFinalAssetDelete(asset) {
      this.uploadingFinalAssets = this.uploadingFinalAssets.filter(
        a => a.resumableFile.uniqueIdentifier !== asset.resumableFile.uniqueIdentifier
      );
    },
    async handleWorkingFileSuccess(file) {
      const asset = this.uploadingWorkingFiles.find(a => a.resumableFile.uniqueIdentifier == file.uniqueIdentifier);
      if (asset) {
        try {
          await this.addCurrentProjectWorkingFile({ asset });
          this.uploadingWorkingFiles = this.uploadingWorkingFiles.filter(
            a => a.resumableFile.uniqueIdentifier !== file.uniqueIdentifier
          );
        } catch (err) {
          console.error('Server error when adding working file', err);
          asset.uploadError = true;
          asset.uploadErrorMessage = err.message;
          this.showError('Error when adding working file');
        }
      }
    },
    handleWorkingFileError(file, message) {
      const asset = this.uploadingWorkingFiles.find(
        a => a.uploadingWorkingFiles.uniqueIdentifier == file.uniqueIdentifier
      );
      if (asset) {
        console.error('Server error when adding working file', message);
        asset.uploadError = true;
        asset.uploadErrorMessage = message;
        this.showError('Error when adding working file');
      }
    },
    handleWorkingFileDelete(asset) {
      this.uploadingWorkingFiles = this.uploadingWorkingFiles.filter(
        a => a.resumableFile.uniqueIdentifier !== asset.resumableFile.uniqueIdentifier
      );
    }
  },
  async mounted() {
    this.fetchCurrentProjectFinalAssets();
    this.fetchCurrentProjectWorkingFiles();
    this.fetchCurrentProjectFileRequests('delivery').then(items => {
      this.fileRequestsItems = items;
    });
    this.finalAssetsResumable.on('fileSuccess', file => {
      this.handleFinalAssetSuccess(file);
    });
    this.finalAssetsResumable.on('fileError', (file, message) => {
      this.handleFinalAssetError(file, message);
    });
    this.workingFilesResumable.on('fileSuccess', file => {
      this.handleWorkingFileSuccess(file);
    });
    this.workingFilesResumable.on('fileError', (file, message) => {
      this.handleWorkingFileError(file, message);
    });
  },
  watch: {
    finalAssetsError(value) {
      if (value) {
        this.showError(value);
      }
    },
    workingFilesError(value) {
      if (value) {
        this.showError(value);
      }
    }
  }
};
</script>
